import { render, staticRenderFns } from "./StudentCheckTitle.vue?vue&type=template&id=66cb8374&scoped=true"
import script from "./StudentCheckTitle.vue?vue&type=script&lang=js"
export * from "./StudentCheckTitle.vue?vue&type=script&lang=js"
import style0 from "./StudentCheckTitle.vue?vue&type=style&index=0&id=66cb8374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb8374",
  null
  
)

export default component.exports